import { map } from 'lodash'
import moment from 'moment'

const prepareShow = moving => {
  const gotInOut = moment(moving.go_in_out, 'YYYYMMDD').format('YYYY-MM-DD')
  const isBefore = moment(gotInOut).isBefore(moment(new Date(), 'YYYYMMDD').format('YYYY-MM-DD'))
  if (isBefore) {
    moving._lock_go_in_out = true
  }
  moving.go_in_out = moment(moving.go_in_out, 'YYYYMMDD').format('YYYY-MM-DD')
  return moving
}

const prepareSave = moving => {
  return moving
}

export default {
  prepareSave,
  prepareShow,
  afterCreated () {
    this.$toast.success('Mudança incluida com sucesso.')
    return this.$router.push({name: 'tenant.moving.index'})
  },
  afterUpdated () {
    this.$toast.success('Mudança alterada com sucesso.')
    return this.$router.push({name: 'tenant.moving.index'})
  },
  showActions (actions) {
    if (actions) {
      this.show = false
    } else {
      this.show = true
    }
  },
  /** Retornando as torres das uniades do dweller */
  getTowersDweller () {
    this.$http.get('/v1/dweller/towers/search')
      .then(({data}) => {
        const towers = map(data, function (item) {
          return {
            id: item.id,
            number: item.number + ' - ' + item.name
          }
        })
        this.dwellerTowers = towers
      })
  },
  /** Retornando as unidades da torre selecionada */
  selectUnitsTower (tower) {
    if (typeof tower === 'object') {
      this.$http.get('/v1/dweller/units/search/' + tower.id)
      .then(({data}) => {
        this.dwellerUnits = data
      })
    }

    if (typeof tower !== 'object') {
      this.$http.get('/v1/dweller/units/search/' + tower)
      .then(({data}) => {
        this.dwellerUnits = data
      })
    }
  },
  getGaragesDwellerEdit (unit, tower) {
    if (typeof unit !== 'object') {
      const search = {
        unit_id: unit,
        tower_id: tower
      }
      this.$http.post('/v1/dweller/garages/search', search)
        .then(({data}) => {
          this.garages = data
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/moving/form/resources/methods.js